// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpertPharmacist_wrapper__a7PZ6","img":"ExpertPharmacist_img__baD5r"};